// removed by extract-text-webpack-plugin
module.exports = {"container":"FlightInfoRow__container__3wNn2","header":"FlightInfoRow__header__1iG7d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoting/Board/FlightInfo/FlightInfoRow/FlightInfoRow.scss
// module id = 643
// module chunks = 0